import React, { useContext, useEffect, useState } from 'react';
import { homeScroll } from '../smoothScroll';
import { Link } from 'react-router-dom';
import slugify from '../utils/slugify';
import LogContext from '../context/LogContext';
const backendUrl = process.env.REACT_APP_BACKEND_URL;
const adminUrl = process.env.REACT_APP_ADMIN_BACKEND_URL;
const Newsletter = () => {
  const [email, setEmail] = useState();
  const [collections, setCollections] = useState([]);
  const category = useContext(LogContext);


  const sendEmail = async () => {
    try {
      const response = await fetch(`${backendUrl}/newsletter`, {
      method: "POST",
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify({ email })
    });
      if (response.ok) {
        alert("Subscribed")
      }
    } catch (error) {
      console.log("Error sending email")
    }
  };
  const getCollections = async () => {
    try {
       const response = await fetch(`${adminUrl}/getCollections`, {
      method: 'GET',
      headers: {
        "content-type": "application/json"
      }
    });
      if (response.ok) {
        const data = await response.json();
        setCollections(data);
      }
      else {
        console.log("cant get the collections data")
      }
    } catch (error) {
      console.log("error occured getting collections data", error)
    }
  }

  useEffect(() => {
    getCollections();
  }, []);
  return (
    <section id="newsletter" className="newsletter" style={{ maxWidth: '100%', overflowX: 'hidden' }}>
      <div className="container">
        <div className="hm-footer-details">
          <div className="row">
            <div className="col-md-3 col-sm-6 col-xs-12">
              <div className="hm-footer-widget">
                <div className="hm-foot-title">
                  <h4>help & information</h4>
                </div>
                <div className="hm-foot-menu">
                  <ul>
                    <li><Link to="/about">about us</Link></li>
                    <li><Link to="/contact">contact us</Link></li>
                    <li><Link to='/collection/all/all'
                      onClick={() => {
                        homeScroll('forshop');
                        category.updateCategory("All");
                        category.updateSubcategory("All");
                      }}
                    >store</Link></li>
                    <li><Link to="/blog">blog</Link></li>
                    <li><Link to="/track-order">track order</Link></li>
                    <li><Link to="/return-policy">return policy</Link></li>
                    <li><Link to="/privacy-policy">privacy policy</Link></li>
                    <li><Link to="/shipping-policy">shipping policy</Link></li>
                    {/* <li><Link to="/terms">terms & condition</Link></li> */}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 col-xs-12">
              <div className="hm-footer-widget">
                <div className="hm-foot-title">
                  <h4>collections</h4>
                </div>
                <div className="hm-foot-menu">
                  <ul>
                    {collections.map((collection) => (
                      <li key={collection._id}><Link to={`/collection/${slugify(collection.title)}/all`}
                        onClick={() => {
                          homeScroll('forshop');
                          category.updateCategory("All");
                          category.updateSubcategory("All");
                        }}>{collection.title}</Link></li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 col-xs-12">
              <div className="hm-footer-widget">
                <div className="hm-foot-title">
                  <h4>my accounts</h4>
                </div>
                <div className="hm-foot-menu">
                  <ul>
                    <li><Link to="/account/personal-info">my account</Link></li>
                    <li><Link to="/account/wishlist">wishlist</Link></li>
                    <li><Link to="/account/orders">order history</Link></li>
                    <li><Link to="/cart">my cart</Link></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 col-xs-12">
              <div className="hm-footer-widget">
                <div className="hm-foot-title">
                  <h4>newsletter</h4>
                </div>
                <div className="hm-foot-para">
                  <p>
                    Subscribe to get the latest news, updates, and information.
                  </p>
                </div>
                <div className="hm-foot-email">
                  <div className="foot-email-box">
                    <input type="text" className="form-control" placeholder="Enter Email Here...." onChange={(e) => { setEmail(e.target.value) }} />
                  </div>
                  <div className="foot-email-subscribe">
                    <span><i className="fa fa-location-arrow" style={{ cursor: "pointer" }} onClick={sendEmail}></i></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      <div className="container">
        <div className="hm-footer-copyright text-center">
          <div className="footer-social">
            <a href="https://www.facebook.com/profile.php?id=61579408717811" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-facebook-f"></i></a>
            <a href="https://www.instagram.com/kidorise9?igsh=MXN5NHE1Z282c3lvZQ%3D%3D" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram"></i></a>
            <a href="#"><i className="fa-brands fa-linkedin"></i></a>
            <a href="#"><i className="fa-brands fa-pinterest"></i></a>
            <a href="#"><i className="fa-brands fa-behance"></i></a>
          </div>
          <p>
            &copy; copyright. 2025 Kidorise
          </p>
        </div>
      </div>
      <div id="scroll-Top">
        <div className="return-to-top">
          <i className="fa fa-angle-up " id="scroll-top" data-toggle="tooltip" data-placement="top" title="" data-original-title="Back to Top" aria-hidden="true" onClick={() => { homeScroll('home') }}></i>
        </div>
      </div>
    </footer>
  );
};

export { Newsletter, Footer };
